/* Global imports. */
import React from "react";
import { nanoid } from 'nanoid';
import HTMLReactParser from "html-react-parser";

/* Component imports. */
import YouTubeEmbed from "@components/YouTubeEmbed";

/* Model imports. */
import KontentYouTubeEmbed from "@models/kontent/KontentYouTubeEmbed";

interface Props {
  title: string;
  introduction: string;
  itemsPerRow: string;
  embeds: Array<{ elements: KontentYouTubeEmbed }>;
  componentID?: string;
}

const YouTubeCollection = ({ title, introduction, itemsPerRow, embeds, componentID }: Props) => {
  const columnClass = () => {
    switch (itemsPerRow) {
      case "n1":
        return "col-span-12";
      case "n2":
        return "col-span-6";
      default:
        return "col-span-4";
    }
  };

  return (
    <section id={componentID} data-component="youtube-collection">
      <div>
        <div>
          {title && <h3>{title}</h3>}
          {introduction && <div>{HTMLReactParser(introduction)}</div>}
        </div>
        <ul className="grid grid-cols-12 gap-x-4 !pl-0 !list-none">
          {embeds.map((embed) => (
            <li key={nanoid()} className={columnClass()}>
              <YouTubeEmbed id={embed.elements.video_id.value} title={embed.elements.title.value} />
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default YouTubeCollection;
